/**
 * PATH: apps/quote/src/pages/BuilderPage.tsx
 * PURPOSE: Builder router (new vs existing quote)
 *
 * WHY:
 * - Routes to BuilderCreate for new quotes (/builder)
 * - Routes to BuilderWorkspaceEditor for existing quotes (/builder/:id)
 * - BuilderWorkspaceEditor provides the premium 3-pane workspace
 */

import { useParams } from 'react-router-dom'
import BuilderCreate from './builder/BuilderCreate'
import BuilderWorkspaceEditor from './builder/BuilderWorkspaceEditor'

export default function BuilderPage() {
  const { id } = useParams<{ id: string }>()

  // For existing quotes, use the premium workspace editor
  if (id) return <BuilderWorkspaceEditor quoteId={id} />
  
  // For new quotes, show the create form
  return <BuilderCreate />
}

